export const COMPANY_DECK_URL = "/PyCray_Company_Deck.pdf";
export const COMPANY_DECK_FILENAME = "PyCray_Company_Deck.pdf";
export const COMPANY_DECK_LABEL = "Download Company Deck (PDF)";
